<template>
    <div class="favorites">
        <!-- 用户信息展示 -->
        <user-info />
        <collection-center />
    </div>
</template>

<script>
import { mapState } from "vuex";
import userInfo from "@/components/user-info";
import collectionCenter from "@/components/collection-center";
export default {
    name: "favorites",
    data() {
        return {};
    },
    computed: {},
    components: {
        userInfo,
        collectionCenter
    },
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {}
};
</script>

<style lang="scss">
.favorites {
}
</style>
